import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCustom = function SvgCustom(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h35v35H0V0Zm10.88 11.01c-.486 0-.88.42-.88.94v14.11c0 .52.394.94.88.94h12.255c.486 0 .88-.42.88-.94V11.95c0-.52-.394-.94-.88-.94h-1.358c-.062-2.679-2.127-4.91-4.77-4.91-2.642 0-4.708 2.231-4.77 4.91H10.88Zm3.158 0h5.939c-.06-1.786-1.422-3.11-2.97-3.11-1.547 0-2.909 1.324-2.969 3.11Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgCustom;